// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"add-dataset-to-case-exercise_tabsWrapper__2xTBK"};